import script from "./MsgChat.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgChat.vue?vue&type=script&setup=true&lang=js"

import "./MsgChat.vue?vue&type=style&index=0&id=6b068f2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b068f2a"]])

export default __exports__